module.exports = __webpack_public_path__ + "img/install.da7d4a22.png";